/**
 * 画布提示词长度上限：与后端图片/视频基线及首页 PromptInput 的 4000 字标准一致。
 *
 * 画布最终提交的提示词是「上游文本节点 + LLM 输出 + 本节点补充提示词」的合并结果，
 * 因此限制与字数统计都按合并后的总长计算（与 aggregateUpstream 的拼接口径一致）。
 */

export const PROMPT_MAX_LENGTH = 4000;

/** 校验合并后提示词长度，超限返回用户可见错误文案，否则 null */
export function getPromptLengthError(prompt: string): string | null {
  return prompt.length > PROMPT_MAX_LENGTH
    ? `提示词不能超过 ${PROMPT_MAX_LENGTH} 字（当前 ${prompt.length} 字），请精简上游文本或补充提示词`
    : null;
}
